import LobbyGame from './lobby';

export default LobbyGame;
